import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
    store(key: string, content:Object) {
        try {
            window.localStorage.setItem(key, JSON.stringify(content));
        } catch (e) {
            console.log('Crazy time with local storage setItem', e);
        }
    }

    retrieve(key: string) {
        try {
            return JSON.parse(window.localStorage.getItem(key));
        } catch(e) {
            console.log('Crazy time with local storage getItem', e);
            return undefined;
        }
    }
}
